import { Box, Typography } from "@mui/material";
import { object, string, TypeOf } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link } from "react-router-dom";
import { LoadingButton as _LoadingButton } from '@mui/lab';
import styled from "@emotion/styled";
import { useEffect } from "react";
import imgRecover from '../../assets/carta-recover.png';
import { useForgotPasswordMutation } from "../../redux/api/authApi";
import MyToastShow from "../Layout/MyToast";
import FormInput from "./FormInput";

const LoadingButton = styled(_LoadingButton)`
  padding: 0.6rem 0;
  font-weight: 500;
  &:hover {
    transform: translateY(-2px);
  }
`;

const loginSchema = object({
    email: string()
        .min(1, 'Necesitas ingresar un email')
        .email('El email no es valido'),
});

export type RecoverInput = TypeOf<typeof loginSchema>;


const RecoverForm = () => {
    const [forgotPassword, { isLoading, isError, error, isSuccess }] = useForgotPasswordMutation();
    const methods = useForm<RecoverInput>({
        resolver: zodResolver(loginSchema),
    });
    const {
        handleSubmit
    } = methods;

    const onSubmitHandler: SubmitHandler<RecoverInput> = ({ email }) => {
        forgotPassword(email).unwrap().then((res) => {
            MyToastShow({ type: 'success', message: res.message });
        })
        .catch((err) => {
            MyToastShow({ type: 'error', message: err.data.message });
        });
    };

    useEffect(() => {
        if (isError) {
            //@ts-ignore
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (error?.status === 'FETCH_ERROR') {
                MyToastShow({ type: 'error', message: "Error de conexión con el servidor" });
                return
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);


    return (
        <FormProvider {...methods}
        >
            <Box
                component='form'
                onSubmit={handleSubmit(onSubmitHandler)}
                noValidate
                autoComplete='off'
                maxWidth='27rem'
                width='100%'
                sx={{
                    p: { xs: '1rem', sm: '2rem' },
                    paddingTop: '0 !important',
                    borderRadius: 2,
                    backgroundColor: '',

                }}
            >
                {isSuccess ? <>
                    <div style={{ width: '100%', display: 'flex' }}>
                        <img src={imgRecover} alt='imagen carta' style={{ width: '30%', marginBottom: '1rem', margin: '0 auto' }} />
                    </div>

                    <Typography sx={{ mb: '1rem', textAlign: 'center' }}>
                        Hemos enviado un correo a tu cuenta de email para que puedas recuperar tu contraseña.
                    </Typography>
                </> : <>
                    <FormInput name='email' label='Email' type='email' />

                    <LoadingButton
                        variant='contained'
                        sx={{ mt: 1 }}
                        fullWidth
                        disableElevation
                        type='submit'
                        loading={isLoading}
                    >
                        Recuperar
                    </LoadingButton>

                </>
                }
                <Typography sx={{ fontSize: '0.9rem', mt: '1rem' }}>
                    <Link to={'/login'}>Volver a página de acceso</Link>
                </Typography>
            </Box>
        </FormProvider>
    );
}

export default RecoverForm;

